module.exports = __webpack_public_path__ + "img/ef390f6.webp";